import React from "react";
import { Icon } from "@culturehq/components";

import { Trans } from "app/utils";

import StaticWidgetToggle from "./StaticWidgetToggle";

const RecognitionWidget = ({ disabled }) => (
  <tr data-id="recognition">
    {!disabled && (
      <td className="sortable__drag-handler" />
    )}
    <td>
      <Icon icon="ribbon-b" />
    </td>
    <td />
    <td>
      <Trans>Recognition</Trans>
    </td>
    <td className="max-width-300">
      <Trans>
        This is a feed of the latest users who have been recognized for
        exhibiting your organization&#39;s values.
      </Trans>
    </td>
    <td className="max-width-300">
      <Trans>For You</Trans>
    </td>
    <td>
      <StaticWidgetToggle name="recognition" disabled={disabled} />
    </td>
  </tr>
);

export default RecognitionWidget;
